export const addMonths = (date: Date, months: number) => {
  date.setMonth(date.getMonth() + months);
  return date;
};
export const addDays = (date: Date, days: number) => {
  date.setDate(date.getDate() - days);
  return date;
};
